export default "__VITE_ASSET__jiRdN7Yg__"